/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-08-08 10:21:40
 *
 *******************************************************/
// @flow

import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal, TextContainer, TextStyle, Link } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { URL } from 'src/constants/links';
import * as themeRevertAction from 'actions/theme-revert-actions';
import * as themeSetupAction from 'actions/theme-setup-actions';
import { mixpanelV3Helper } from 'src/helpers/mixpanel-v3';

type Props = {
  active: boolean,
  removing: boolean,
  handleChange: () => void,
  handleContinue: () => void
};

type ComposedProps = Props & WithI18nProps;

class ConfirmRevertThemeModal extends Component<ComposedProps> {
  componentWillReceiveProps(nextProps) {
    const { revertThemeLoading, revertThemeSuccess } = nextProps;
    const { revertThemeLoading: prevRevertThemeLoading, getThemes } = this.props;
    if (prevRevertThemeLoading && !revertThemeLoading && revertThemeSuccess) {
      this.handleChange();
      getThemes();
    }
  }
  render() {
    const { i18n, active, dataSetup = {}, revertThemeLoading } = this.props;
    const { theme = {}, removeAll } = dataSetup;
    const { published = false } = theme;

    return (
      <Modal
        open={active}
        onClose={this.handleChange}
        title={
          published
            ? i18n.translate('AdminHTML.ThemeSetup.ConfirmRevertThemeModal.titleLiveTheme')
            : i18n.translate('AdminHTML.ThemeSetup.ConfirmRevertThemeModal.title')
        }
        primaryAction={{
          content: published
            ? i18n.translate(
                'AdminHTML.ThemeSetup.ConfirmRevertThemeModal.action_ContinueLiveTheme'
              )
            : i18n.translate('AdminHTML.ThemeSetup.ConfirmRevertThemeModal.action_Continue'),
          onAction: this.handleContinue,
          destructive: true,
          loading: revertThemeLoading
        }}
        secondaryActions={[
          {
            content: i18n.translate('AdminHTML.Common.Action.cancel'),
            onAction: this.handleChange
          }
        ]}>
        <Modal.Section>
          <TextContainer>
            <TextStyle>
              {published
                ? removeAll
                  ? i18n.translate(
                      'AdminHTML.ThemeSetup.ConfirmRevertThemeModal.contentLiveTheme_RemoveAll',
                      {
                        t1: (
                          <Link external url={URL['DuplicatingThemesDoc']}>
                            {i18n.translate(
                              'AdminHTML.ThemeSetup.ConfirmRevertThemeModal.contentLiveTheme_RemoveAll_t1'
                            )}
                          </Link>
                        )
                      }
                    )
                  : i18n.translate(
                      'AdminHTML.ThemeSetup.ConfirmRevertThemeModal.contentLiveTheme',
                      {
                        t1: (
                          <Link external url={URL['DuplicatingThemesDoc']}>
                            {i18n.translate(
                              'AdminHTML.ThemeSetup.ConfirmRevertThemeModal.contentLiveTheme_t1'
                            )}
                          </Link>
                        )
                      }
                    )
                : removeAll
                ? i18n.translate('AdminHTML.ThemeSetup.ConfirmRevertThemeModal.content_RemoveAll')
                : i18n.translate('AdminHTML.ThemeSetup.ConfirmRevertThemeModal.content')}
            </TextStyle>
          </TextContainer>
        </Modal.Section>
      </Modal>
    );
  }

  handleChange = () => {
    this.props.handleChange();
  };

  handleContinue = () => {
    const { revertTheme, dataSetup } = this.props;
    const { theme = {}, removeAll } = dataSetup;
    const { id = '' } = theme;

    revertTheme({ themeId: id, removeSearchOnly: !removeAll, themeName: theme?.name });
    // Tracking event
    if (!removeAll) {
      mixpanelV3Helper.trackEventData('Remove search on theme', {
        feature: 'Theme Setup',
        selectedTheme: theme?.name
      });
    } else {
      mixpanelV3Helper.trackEventData('Remove all features on theme', {
        feature: 'Theme Setup',
        selectedTheme: theme?.name
      });
    }
  };
}

const mapStateToProps = (state, props) => {
  const { themeRevert } = state;
  return {
    revertThemeLoading: _.get(themeRevert, 'loading', false),
    revertThemeSuccess: _.get(themeRevert, 'success', false)
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  getThemes: () => dispatch(themeSetupAction.getThemes(ownProps.i18n)),
  revertTheme: data => dispatch(themeRevertAction.revertTheme(data, ownProps.i18n))
});

export default withI18n()(connect(mapStateToProps, mapDispatchToProps)(ConfirmRevertThemeModal));
